var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.001,
    height: 33.749,
    viewBox: "0 0 54.001 33.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_graphic",
    d: "M.995,110.514l13.5-13.5a3.375,3.375,0,0,1,4.773,4.773l-7.734,7.736h39.1a3.375,3.375,0,1,1,0,6.75h-39.1l7.74,7.74a3.375,3.375,0,1,1-4.773,4.773L1,115.285A3.366,3.366,0,0,1,.995,110.514Z",
    transform: "translate(54.008 129.774) rotate(180)",
    fill: "#FE5000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGraphic);
export default __webpack_public_path__ + "static/media/arrow_graphic.ce3d9cb3e724f1a599935dc871c29fe6.svg";
export { ForwardRef as ReactComponent };